import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { SuitProgress } from '@cradua/domain';
import { SuitProgressDto, YearOfSuitDto, ClaimTypeDto, LorpDto, CurrencyDto, StateDto, AdrDto, CommunityDto,
  SecurityClassificationDto, DocumentTypeDto, DocumentTypeCodeDto, FiscalFileLocationDto, LgaDto, CounselTypeDto, SuitCounselDto, LandTitleRegisterDto } from '@cradua/data';
import { Observable } from 'rxjs';

@Component({
  selector: 'cradua-viewprogress',
  templateUrl: './viewprogress.component.html',
  styleUrls: ['./viewprogress.component.scss']
})

export class ViewprogressComponent implements OnInit {

  @Input() adrs: AdrDto[];
  @Input() yearofsuits: YearOfSuitDto[];
  @Input() claimtypes: ClaimTypeDto[];
  @Input() lorps: LorpDto[];
  @Input() currencys: CurrencyDto[];
  @Input() states: StateDto[];
  @Input() communitiess: CommunityDto[];
  @Input() securityclassifications: SecurityClassificationDto[];
  @Input() documenttypes: DocumentTypeDto[];
  @Input() documenttypecodes: DocumentTypeCodeDto[];
  @Input() filelocations: FiscalFileLocationDto[];
  @Input() lgas: LgaDto[];
  @Input() counseltypes: CounselTypeDto[];
  @Input() suitcounsels: SuitCounselDto[];
  @Input() fetchDocuments: AdrDto[];
  @Input() isLoadingDocument: boolean;
  @Input() completed: boolean;
  @Input() progress: number;
  @Input() error: string;
  @Input() isInProgress: boolean;
  @Input() isReady: boolean;
  @Input() hasFailed: boolean;
  @Output() emitUpload = new EventEmitter<any>();
  @Output() emitSaveManyDoc = new EventEmitter<any>();
  @Output() emitReset = new EventEmitter<any>();
  @Output() emitCancel = new EventEmitter<any>();

  @Input() adrProgress: SuitProgress[];
  @Output() emitSuitSave = new EventEmitter<SuitProgressDto[]>();
  communities: CommunityDto[];
  counseltype: CounselTypeDto[];
  adrprogressForm: FormGroup;
  AdrData: AdrDto;
  newObject: any[] & AdrDto[];
  searchSuitProgressValue = '';
  searchedSuitProgress: AdrDto[] | any[];
  selectedValue: AdrDto;
  submittedId;
  selectedSuitProgresss: AdrDto;
  showTab = false;
  isExpanded = true;
  isExpanded2 = false;

  constructor(
      private fb: FormBuilder
  ) {}

  ngOnInit() {
    // this.communities = this.communitiess;
    // this.counseltype = this.counseltypes;
    this.adrprogressForm = this.fb.group({
      SuitNo: [''],
      YearOfSuitId: [''],
      PartyA: [''],
      PartyB: [''],
      ClaimTypeId: [''],
      Claims: [''],
      ClaimAmount: [''],
      CurrencyId: [''],
      AmountAsClaimed: [''],
      Defence: [''],
      LorpId: [''],
      StateId: [''],
      Location: [''],
      DateRegisterd: [''],
      InputStaff: [''],
      SuitStatus: [''],
      SubscriptionUserId: ['0'],
      SubscriberId: ['0'],
      SuitStatusRemarks: [''],
      ClosingDate: [''],
      id: ['']
    });

    this.adrprogressForm = this.fb.group({});
    if(this.adrs && this.adrs.length) {
      this.selectedSuitProgresss = this.adrs[0];
      this.onViewOrEdit(this.adrs[0]);
    } else {
      this.selectedSuitProgresss = null;
    }   
  }

  onViewOrEdit(selectedValue: AdrDto) {
    if(selectedValue) {
      this.adrprogressForm.patchValue(selectedValue);
    }
  }

  public errorHandling = (control: string, error: string) => {
    return this.adrprogressForm.controls[control].hasError(error);
  };

  search(value: string) {
    !value
      ? (this.searchedSuitProgress = null)
      : (this.searchedSuitProgress = this.adrs.filter(
          (item) =>
            item.SuitNo.toLowerCase().includes(value.toLowerCase()) ||
            item.PartyA.toLowerCase().includes(value.toLowerCase()) ||
            item.PartyB.toLowerCase().includes(value.toLowerCase())
        ));
  }

  addSuitProgress(value) {
    // Not in use!!!
    // console.log("value: ", this.adrprogressForm);
    this.adrprogressForm.patchValue(value);
  }

  dateTransformation(date) {
    console.log('date: ', date)
    const d = new Date(date);
    let day = '' + d.getDate();
    let month = '' + (d.getMonth() + 1);
    const year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }

    if (day.length < 2) {
      day = '0' + day;
    }
    return [year, month, day].join('-');
  }

  onCreate() {
    this.adrprogressForm.reset();
  }

  getSuitYear(id){
    return this.yearofsuits.find(p => p.id === id);
  }

  getClaimType(id){
    return this.claimtypes.find(p => p.id === id);
 }


 getLorp(id){
  return this.lorps.find(p => p.id === id);
}

getCurrency(id){
  return this.currencys.find(p => p.id === id);
}

onUploadFile(value) {
  this.emitUpload.emit(value);
}

onSaveManyDoc(value: LandTitleRegisterDto[]) {
  this.emitSaveManyDoc.emit(value);
}

onCancelUpload(val) {
  this.emitCancel.emit('');
}

onResetUpload(val) {
  this.emitReset.emit('');
}

onEmitSuitSubmit(formValue) {
  this.emitSuitSave.emit(formValue);
}
}
